import React from 'react';
import {useDispatch} from 'react-redux';
import { changeFeedbackModalState } from '../../store/actionCreators';
import {Link} from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import TrovaLogo from '../../components/TrovaLogo/TrovaLogo';
import * as Styled from './SearchPortalStyles';
import SearchInput from "../../components/SearchInput/SearchInput";
import Meta from '../../components/Meta/Meta';
import {Paragraph, Box} from '../../styled';

const SearchPortal = () => {
  const dispatch = useDispatch();

  const openFeedbackModal = (e:any) => {
    e.preventDefault();
    dispatch(changeFeedbackModalState());
  }

  return (
    <Styled.Container className='SearchPortalWrapper'>
      <Meta page="searchportal" />
      <Navigation hasLogo={false} />
      <Styled.Container className='MainWrapper'>
        <TrovaLogo size="lg" />
        <Styled.LogoName>Trova</Styled.LogoName>
        <Styled.SearchContainer>
          <SearchInput noMargin />
        </Styled.SearchContainer>
        <Link to='/about'>About Trova</Link>
      </Styled.Container>
      <Box
        display={'flex'}
        justifyContent={['center', 'space-between']}
        flexDirection={['column-reverse', 'row']}
        p={'0px 50px'}
        position={'absolute'}
        mb={[0, 20]}
        bottom={0}
        width={'100%'}
      >
        <Paragraph mb={0} align={'center'} color={'greyDark'}>
          &#169; Trova {new Date().getFullYear()}
        </Paragraph>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          flexDirection={['column', 'row']}
        >
          <Link className="footerLink" to='/' onClick={openFeedbackModal}>Feedback</Link>
          <Link className="footerLink" to='/about#faq'>FAQs</Link>
          <Link className="footerLink" to="/security">Security Practices</Link>
        </Box>
        <Box />
      </Box>
      {/*<Styled.Footer>
        <Styled.StyledParagraph className='copyright'>
          &#169; Trova {new Date().getFullYear()}
        </Styled.StyledParagraph>
        <Styled.LinksContainer>
          <Link to='/' onClick={openFeedbackModal}>Feedback</Link>
          <Link to='/about#faq'>FAQs</Link>
          <Link to="/security">Security Practices</Link>
        </Styled.LinksContainer>
        <Styled.StyledParagraph>

        </Styled.StyledParagraph>
      </Styled.Footer>*/}
    </Styled.Container>
  );
}

export default SearchPortal;